import {AxiosError, AxiosResponse, CancelTokenSource} from 'axios';

import {Completable, failed} from 'kashable-mobile-common';

const REQUEST_CANCEL_CODE = 'CANCEL';

export function cancel (cts:CancelTokenSource) {
    cts.cancel(REQUEST_CANCEL_CODE);
}

export function isCancel<T>(comp:Completable<T>) : boolean {
    return comp.error === REQUEST_CANCEL_CODE;
}

export function errored<T>(error: AxiosError<string>): Completable<T> {
    if (error.response) {
        const {response} = error;
        const {headers, status} = response;

        return failed({
            message: response.data,
            code: status,
            headers,
        });
    } else if (error.code === 'ECONNABORTED' || error.message === REQUEST_CANCEL_CODE) {
        return failed({
            message: error.message,
            code: 408,
            headers: {},
        });
    } else {
        return failed({
            message: 'There was an error',
            code: 500,
            headers: {},
        });
    }
}

export function succeeded<T>(response: AxiosResponse<T>): Completable<T> {
    return mapSucceeded<T, T>(response, (d) => d);
}

export function mapSucceeded<T, U = T>(
    response: AxiosResponse<T>,
    mapper: (t: T) => U | undefined,
): Completable<U> {
    const {data, headers, status} = response;

    return {
        value: mapper(data),
        code: status,
        headers,
        pending: false,
    };
}
